import { render } from "./ServiceDetail.vue?vue&type=template&id=99851988&scoped=true&ts=true"
import script from "./ServiceDetail.vue?vue&type=script&lang=ts"
export * from "./ServiceDetail.vue?vue&type=script&lang=ts"

import "./ServiceDetail.vue?vue&type=style&index=0&id=99851988&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99851988"]])

export default __exports__